<template>
    <access-denied v-if="accessDenied" title="agenda" />
    <div id="main" v-else>
        <loader v-if="isLoading" />
        <div class="page">
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('agenda') }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs" v-if="cameFrom == 'route'">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('despesas') }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'crm-agenda-list',
                                            })
                                        "
                                        >{{ $t('agenda') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? $route.params.id : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <!-- Colaboradores -->
                        <div class="sovis-container-user" @click="showModal = true" v-if="isUpdate">
                            <b-icon icon="eye" type="is-primary" class="mr-2" />
                            <div
                                v-if="evento.colaborador_executado_qtd != 0"
                                class="qtd-users is-success"
                                :title="$t('finalizado')"
                            >
                                {{ evento.colaborador_executado_qtd }}
                            </div>
                            <span
                                v-if="
                                    evento.colaborador_executado_qtd != 0 &&
                                    evento.colaborador_aberto_qtd != 0
                                "
                            >
                                •
                            </span>
                            <div
                                v-if="evento.colaborador_aberto_qtd != 0"
                                class="qtd-users is-danger"
                                :title="$t('aberto')"
                            >
                                {{ evento.colaborador_aberto_qtd }}
                            </div>
                        </div>
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                ((!isUpdate && permissao.create) ||
                                    (isUpdate && permissao.update)) &&
                                !integracao
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving || evento.situacao == 0 || cantEdit"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-8">
                            <v-input
                                ref="nomeInput"
                                v-model="evento.crmAgenda.titulo"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="titulo"
                                msg="msg-campo-obrigatorio"
                                :invalid="isNull(evento.crmAgenda.titulo)"
                                required
                                :disabled="cantEdit || isSaving"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                ref="tipoAgendaListInput"
                                label="descricao"
                                title="tipo"
                                v-model="tipoAgendaSelected"
                                placeholder="selecione-uma-opcao"
                                :options="tipoAgendaList"
                                :loading="tipoAgendaLoading"
                                :disabled="cantEdit || isSaving || isUpdate"
                                @search="carregarTipoAgenda($event)"
                                searchable
                                required
                                :invalid="tipoAgendaSelected == null"
                            />
                        </div>
                        <div class="column is-full">
                            <vms-select
                                ref="colaboradorSelected"
                                label="nome"
                                required
                                title="colaboradores"
                                v-model="colaboradorSelected"
                                :invalid="colaboradorSelected.length == 0"
                                :options="colaboradorList"
                                :loading="colaboradorLoading"
                                @search="carregarColaborador($event)"
                                :disabled="cantEdit || isSaving || isUpdate"
                                :close-on-select="false"
                                placeholder="selecione-uma-opcao"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                ref="clienteSelect"
                                title="cliente"
                                label="nome"
                                :options="clienteSelect"
                                v-model="clienteSelected"
                                :loading="clienteLoading"
                                @onBlurFunction="carregarPropriedade()"
                                @search="carregarCliente($event)"
                                searchable
                                clearable
                                :disabled="cantEdit || isSaving || isUpdate"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                v-show="
                                    propriedadeSelect.length != 0 ||
                                    (isUpdate && propriedadeSelected != null)
                                "
                                ref="propriedadeSelect"
                                title="propriedade"
                                searchable
                                clearable
                                :options="propriedadeSelect"
                                v-model="propriedadeSelected"
                                :loading="propriedadeLoading"
                                @search="carregarPropriedade($event)"
                                :disabled="cantEdit || isSaving || isUpdate"
                            />
                        </div>
                        <!-- Data Inicio-->
                        <div class="column is-4">
                            <verified-date-picker
                                ref="datainicialSelect"
                                placeholder="selecione-uma-data"
                                dateType="startDate"
                                v-model="datainicial"
                                :endDate="
                                    datafinal == null
                                        ? $moment().add(1, 'years').toDate()
                                        : datafinal
                                "
                                required
                                :addDateYears="2"
                                :title="repeticaoSelected.id == 0 ? 'data' : 'a-partir-de'"
                                inForm
                                :showClean="false"
                                :invalid="datainicial == null"
                                :disabled="cantEdit || isSaving || isUpdate"
                                position="is-bottom-right"
                                @input="
                                    selectDiaDaSemana($event);
                                    resetByDataInicio($event);
                                "
                            />
                        </div>
                        <div class="column is-2">
                            <VerifiedTimePicker
                                ref="horaInicioSelect"
                                title="hora-inicio"
                                v-model="horaInicio"
                                :disabled="cantEdit || isSaving || isUpdate"
                                required
                                :invalid="horaInicio.HH == '' || horaInicio.mm == ''"
                                hideClearButton
                            />
                        </div>
                        <div class="column is-2">
                            <VerifiedTimePicker
                                ref="horaFimSelect"
                                title="hora-fim"
                                v-model="horaFim"
                                :disabled="cantEdit || isSaving || isUpdate"
                                required
                                :invalid="horaFim.HH == '' || horaFim.mm == ''"
                                hideClearButton
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                v-if="diaSemanaSelectedFromDataInicial != null"
                                ref="repeticaoSelect"
                                :searchable="false"
                                :options="repeticaoSelect"
                                v-model="repeticaoSelected"
                                class="no-clear"
                                mlLabels
                                title="repeticao"
                                @input="resetRepeticao($event)"
                                :disabled="cantEdit || isUpdate || datainicial == null"
                            >
                                <template v-slot:selected="{ option }">
                                    <span class="option-label" :title="getLabelRepeticao(option)">
                                        {{ getLabelRepeticao(option) }}
                                    </span>
                                </template>
                                <template v-slot:option="{ option }">
                                    <span class="option-label" :title="getLabelRepeticao(option)">
                                        {{ getLabelRepeticao(option) }}
                                    </span>
                                </template>
                            </vss-select>
                        </div>
                    </div>
                    <div class="columns is-flex-wrap" v-if="repeticaoSelected.id != 0">
                        <div class="column is-8">
                            <vms-select
                                ref="diaSemanaSelect"
                                title="dias-da-semana"
                                v-model="diasSemanaSelected"
                                :options="diasSemanaSelect"
                                :disabled="
                                    cantEdit || isSaving || isUpdate || repeticaoSelected.id != 1
                                "
                                :close-on-select="false"
                                @input="ordenaDias($event)"
                                mlLabels
                                :invalid="
                                    [1, 2, 3].includes(repeticaoSelected.id) &&
                                    diasSemanaSelected.length == 0
                                "
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                ref="terminaPorSelect"
                                :searchable="false"
                                :options="terminaPorSelect"
                                v-model="terminaPorSelected"
                                :disabled="cantEdit || isSaving || isUpdate"
                                class="no-clear"
                                mlLabels
                                title="termina-por"
                                @input="changeTerminaPor($event)"
                            />
                        </div>
                        <div class="column is-4" v-if="terminaPorSelected.id == 0">
                            <verified-date-picker
                                ref="datafinalSelect"
                                placeholder="selecione-uma-data"
                                dateType="endDate"
                                v-model="datafinal"
                                :startDate="datainicial"
                                :addDateYears="2"
                                title="termina-em"
                                inForm
                                :showToday="false"
                                showClean
                                :disabled="cantEdit || isSaving || isUpdate"
                                required
                                :invalid="datafinal == null"
                                position="is-top-right"
                            />
                        </div>
                        <div class="column is-3" v-if="terminaPorSelected.id == 1">
                            <v-money
                                ref="repeticao_qtd_ocorrenciasNumber"
                                title="qtd-ocorrencias"
                                v-model="evento.crmAgenda.repeticao_qtd_ocorrencias"
                                :invalid="evento.crmAgenda.repeticao_qtd_ocorrencias < 2"
                                :disabled="cantEdit || isSaving || isUpdate"
                                :precision="0"
                                alingCenter
                                @blur="onBlurQtdOcorrencias"
                            />
                        </div>
                    </div>
                    <div class="columns is-flex-wrap">
                        <div class="column is-12">
                            <v-textarea
                                ref="observacaoTextarea"
                                v-model="evento.crmAgenda.observacao"
                                title="observacao-geral"
                                placeholder="placeholder-preencha"
                                :rows="4"
                                :maxRows="4"
                                :maxlength="500"
                                :disabled="cantEdit || isSaving"
                            />
                        </div>
                        <div class="column is-6">
                            <label class="label-medium">{{ $t('notificacao') }}</label> <br />
                            <!-- <div class="group-buttons"> -->
                            <b-button
                                :type="notificacao.topo ? 'is-primary' : ''"
                                :outlined="!notificacao.topo"
                                @click="changeCheckTopo()"
                                icon-left="bell-ring-outline"
                                :disabled="cantEdit || isSaving || isUpdate"
                            >
                                {{ $t(notificacao.topo ? 'ativa' : 'inativa') }}
                                <!-- {{ $t('notifica') }} -->
                            </b-button>
                            <!-- <b-button
                                    :id="generateId(9)"
                                    :type="notificacao.pupup ? 'is-primary' : ''"
                                    :outlined="!notificacao.pupup"
                                    @click="changeCheckPupUp()"
                                    icon-left="message-outline"
                                    :disabled="cantEdit || isSaving || isUpdate"
                                >
                                    {{ $t('mensagem') }}
                                </b-button> -->
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- compact -->
        <lateral-content v-model="showModal" header :title="evento.crmAgenda.titulo">
            <div class="bg p-3" v-if="showModal">
                <AgendaUsuarioList
                    :evento="evento"
                    :reloadData="isLoading"
                    @saved="
                        carregarDados();
                        $emit('updated', true);
                    "
                />
            </div>
        </lateral-content>
    </div>
</template>

<script>
import CrmAgendaService from '@/services/vendas/crm/CrmAgendaService.js';
import TipoAgendaAtividadeService from '@/services/TipoAgendaAtividadeService.js';
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService.js';
import VendasClienteService from '@/services/VendasClienteService.js';
import PropriedadeService from '@/services/agro/PropriedadeService.js';
import AgendaValidation from '@/services/validations/crm/agenda/CrmAgendaValidation.js';
import VerifiedTimePicker from '@/components/shared/form/VerifiedTimePicker.vue';
const AgendaUsuarioList = () => import('@/components/vendas/agenda/AgendaUsuarioList.vue');

export default {
    name: 'CrmAgendaManage',
    components: {
        VerifiedTimePicker,
        AgendaUsuarioList,
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: String,
            default: null,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
        newEvent: {
            type: Object,
            default: (_) => null,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('AGENDAATIVIDADE'),
            service: new CrmAgendaService(this.$http, this.$router),
            tipoAgendaService: new TipoAgendaAtividadeService(this.$http, this.$router),
            gerenciarUsuariosService: new GerenciarUsuariosService(this.$http, this.$router),
            clienteService: new VendasClienteService(this.$http, this.$router),
            servicePropriedade: new PropriedadeService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new AgendaValidation(),
            isUpdate: false,
            accessDenied: false,
            
            cantEdit: false,
            evento: {
                replicapda: null,
                idcrm_agenda_evento: null,
                idcrm_agenda_eventoerp: null,
                uuid: null,
                uuidcrm_agenda: null,
                data_hora_inicio: null,
                data_hora_fim: null,
                observacao: null,
                situacao: 1,
                notificacao: null,
                crmAgenda: {
                    replicapda: null,
                    idcrm_agenda: null,
                    idcrm_agendaerp: null,
                    uuid: null,
                    titulo: null,
                    idtipoagendaatividade: null,
                    idcliente: null,
                    uuidpropriedade: null,
                    observacao: null,
                    idusuario_insercao: null,
                    repeticao_data_inicio: null,
                    repeticao_data_fim: null,
                    repeticao_qtd_ocorrencias: 2,
                    repeticao_tipo: null,
                    repeticao_dias: null,
                    situacao: 1,
                    cliente: null,
                    diaSemanaSelectedFromDataInicial: null,
                    lastOccurrenceDayOfWeekInMonth: false,
                },
                crmAssAgendaEventoUsuarioList: [],
            },
            tipoAgendaList: [],
            tipoAgendaSelected: null,
            tipoAgendaLoading: false,
            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,
            clienteSelect: [],
            clienteSelected: null,
            clienteLoading: false,
            propriedadeSelect: [],
            propriedadeSelected: null,
            propriedadeLoading: true,
            datainicial: new Date(),
            datafinal: null,
            horaInicio: {
                HH:
                    new Date().getHours() < 10
                        ? '0' + new Date().getHours().toString()
                        : new Date().getHours().toString(),
                mm:
                    new Date().getMinutes() < 10
                        ? '0' + new Date().getMinutes().toString()
                        : new Date().getMinutes().toString(),
            },
            horaFim: {
                HH:
                    this.addHours(new Date(), 1).getHours() < 10
                        ? '0' + this.addHours(new Date(), 1).getHours().toString()
                        : this.addHours(new Date(), 1).getHours().toString(),
                mm:
                    this.addHours(new Date(), 1).getMinutes() < 10
                        ? '0' + this.addHours(new Date(), 1).getMinutes().toString()
                        : this.addHours(new Date(), 1).getMinutes().toString(),
            },
            repeticaoSelect: [
                { label: 'inativa', id: 0 },
                { label: 'personalizada', id: 1 },
                { label: 'semanal', id: 2 },
                { label: 'mensal', id: 3 },
                { label: 'mensal', id: 4 },
            ],
            repeticaoSelected: { label: 'inativa', id: 0 },
            terminaPorSelect: [
                { label: 'data-final', id: 0 },
                { label: 'qtd-ocorrencias', id: 1 },
            ],
            terminaPorSelected: { label: 'data-final', id: 0 },
            diasSemanaSelect: [
                { value: 1, label: 'domingo' },
                { value: 2, label: 'segunda' },
                { value: 3, label: 'terca' },
                { value: 4, label: 'quarta' },
                { value: 5, label: 'quinta' },
                { value: 6, label: 'sexta' },
                { value: 7, label: 'sabado' },
            ],
            diasSemanaSelected: [],
            notificacao: { topo: false, pupup: false },
            diaSemanaSelectedFromDataInicial: null,
            lastOccurrenceDayOfWeekInMonth: false,
            occurrenceOfDayInMonth: 0,
            showModal: false,
        };
    },
    created() {
        if (this.idFrom != null) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'crm-agenda');
        if (!this.isUpdate && !this.permissao.create) {
            this.accessDenied = true;
        } else if (this.isUpdate) {
            this.cantEdit = !this.permissao.update;
            this.carregarDados();
        } else {
            this.carregarTipoAgenda();
            this.carregarColaborador();
            this.colaboradorSelected.push({
                id: this.$store.state.user.usuario.id,
                idusuario: this.$store.state.user.usuario.idusuario,
                nome: this.$store.state.user.usuario.nome,
            });
            this.selectDiaDaSemana(this.datainicial);
            // dados vindos do componente de calendário
            if (this.newEvent != null) {
                this.datainicial = this.newEvent.start;
                this.horaInicio.HH =
                    this.newEvent.start.getHours() < 10
                        ? '0' + this.newEvent.start.getHours().toString()
                        : this.newEvent.start.getHours().toString();
                this.horaInicio.mm =
                    this.newEvent.start.getMinutes() < 10
                        ? '0' + this.newEvent.start.getMinutes().toString()
                        : this.newEvent.start.getMinutes().toString();
                this.horaFim.HH =
                    this.newEvent.end.getHours() < 10
                        ? '0' + this.newEvent.end.getHours().toString()
                        : this.newEvent.end.getHours().toString();
                this.horaFim.mm =
                    this.newEvent.end.getMinutes() < 10
                        ? '0' + this.newEvent.end.getMinutes().toString()
                        : this.newEvent.end.getMinutes().toString();
            }
        }
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados();
        },
    },
    methods: {
        generateId(numberId) {
            return 'AgendaManage-' + numberId;
        },
        onBlurQtdOcorrencias() {
        const val = Number(this.evento.crmAgenda.repeticao_qtd_ocorrencias);
        if (isNaN(val) || val < 2) {
            this.evento.crmAgenda.repeticao_qtd_ocorrencias = 2;
        }
        },
        carregarTipoAgenda(query = null) {
            if (this.isUpdate) {
                this.tipoAgendaLoading = false;
                return;
            }

            this.tipoAgendaLoading = true;
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.tipoAgendaService
                .findAllCombo(query)
                .then((value) => {
                    if (value.content != null) {
                        this.tipoAgendaList = value.content;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.tipoAgendaLoading = false;
                });
        },
        carregarColaborador(query = null) {
            if (this.isUpdate) {
                this.colaboradorLoading = false;
                return;
            }

            this.colaboradorLoading = true;
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.gerenciarUsuariosService
                .findAllCombo(query)
                .then((value) => {
                    if (value.content != null) {
                        this.colaboradorList = value.content;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.colaboradorLoading = false;
                });
        },
        carregarCliente(query) {
            if (this.isUpdate) {
                this.clienteLoading = false;
                return;
            }

            this.clienteLoading = true;
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.clienteService
                .findAllCombo(query)
                .then((value) => {
                    if (value.content != null) {
                        this.clienteSelect = value.content;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        carregarPropriedade(query = null) {
            if (this.isUpdate) {
                this.propriedadeLoading = false;
                return;
            }

            if (!this.isLoading) this.propriedadeSelected = null;
            this.propriedadeSelect = [];
            if (this.clienteSelected == null) return;

            this.propriedadeLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(query) ? '.*' : this.removeToSearch(query),
                // parâmetro adicional com o nome do que deve ser filtrado
                'cliente',
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.clienteSelected.id,
            ];

            this.servicePropriedade
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            uuid: i.uuid,
                            label: i.nome,
                            origempda: i.origempda,
                        };
                    });
                })
                .then((value) => {
                    this.propriedadeSelect = Object.assign(value);
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.propriedadeLoading = false;
                });
        },
        carregarDados() {
            this.isLoading = true;
            this.service
                .find(this.idFrom)
                .then((value) => {
                    this.evento = value.content;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally(() => {
                    if (this.evento.uuid != null) {
                        this.tipoAgendaSelected = this.evento.crmAgenda.tipoAgendaAtividade;

                        this.colaboradorSelected = this.evento.crmAssAgendaEventoUsuarioList.map(
                            (m) => m.usuario
                        );

                        if (this.evento.crmAgenda.cliente != undefined) {
                            this.clienteSelected = this.evento.crmAgenda.cliente;
                            if (this.evento.crmAgenda.propriedade != undefined) {
                                this.propriedadeSelected = {
                                    uuid: this.evento.crmAgenda.propriedade.uuid,
                                    label: this.evento.crmAgenda.propriedade.nome,
                                    origempda: this.evento.crmAgenda.propriedade.origempda,
                                };
                            }
                        }

                        this.datainicial = new Date(this.evento.data_hora_inicio);
                        let horaFimTemp = new Date(this.evento.data_hora_fim);

                        this.horaInicio.HH =
                            this.datainicial.getHours() < 10
                                ? '0' + this.datainicial.getHours().toString()
                                : this.datainicial.getHours().toString();
                        this.horaInicio.mm =
                            this.datainicial.getMinutes() < 10
                                ? '0' + this.datainicial.getMinutes().toString()
                                : this.datainicial.getMinutes().toString();
                        this.horaFim.HH =
                            horaFimTemp.getHours() < 10
                                ? '0' + horaFimTemp.getHours().toString()
                                : horaFimTemp.getHours().toString();
                        this.horaFim.mm =
                            horaFimTemp.getMinutes() < 10
                                ? '0' + horaFimTemp.getMinutes().toString()
                                : horaFimTemp.getMinutes().toString();

                        if (this.evento.notificacao == 2) {
                            this.notificacao.topo = true;
                            this.notificacao.pupup = true;
                        } else if (this.evento.notificacao == 1) {
                            this.notificacao.topo = true;
                        }
                        // não pode alterar eventos anteriores a data atual
                        if (
                            horaFimTemp < new Date() ||
                            (!this.$store.state.user.admin &&
                                this.$store.state.user.usuario.id !=
                                    this.evento.crmAgenda.idusuario_insercao)
                        )
                            this.cantEdit = true;

                        let crmAssAgendaEventoUsuarioList = this.mapColaboradorList(
                            this.evento.crmAssAgendaEventoUsuarioList,
                            this.evento.data_hora_fim,
                            this.evento.crmAgenda.idusuario_insercao
                        );
                        this.evento.crmAssAgendaEventoUsuarioList = crmAssAgendaEventoUsuarioList;

                        let haveMe = crmAssAgendaEventoUsuarioList.reduce(
                            (n, f) => (f.idusuario == this.$store.state.user.usuario.id ? n + 1 : n),
                            0
                        );
                        let iCanChange = crmAssAgendaEventoUsuarioList.reduce(
                            (n, f) => (f.iCanChange ? n + 1 : n),
                            0
                        );
                        this.evento.colaboradorHaveMe = haveMe > 0;
                        this.evento.iCanChange =
                            iCanChange > 0 ||
                            (crmAssAgendaEventoUsuarioList == 0 && this.$store.state.user.admin);

                        this.evento.colaborador_executado_qtd = this.evento.crmAssAgendaEventoUsuarioList.reduce(
                            (n, f) => (f.crmAgendaExecucao != undefined ? n + 1 : n),
                            0
                        );
                        this.evento.colaborador_aberto_qtd = this.evento.crmAssAgendaEventoUsuarioList.reduce(
                            (n, f) => (f.crmAgendaExecucao == undefined ? n + 1 : n),
                            0
                        );

                        if (
                            this.evento.colaborador_executado_qtd > 0 &&
                            this.evento.colaborador_aberto_qtd == 0
                        ) {
                            this.cantEdit = true;
                        }
                    }

                    this.isLoading = false;
                });
        },
        mapColaboradorList(colaboradorList, data_hora_fim, idusuario_insercao) {
            data_hora_fim = new Date(data_hora_fim);
            let agora = new Date();
            return colaboradorList.map((m) => {
                let isSubordinado = this.$store.state.user.usuario.assusuariousuarioList.reduce(
                    (n, f) => (f.idusuario = m.idusuario ? n + 1 : n),
                    0
                );
                let iCanChange =
                    (isSubordinado > 0 && idusuario_insercao == this.$store.state.user.usuario.id) ||
                    this.$store.state.user.admin;
                return {
                    id: m.id,
                    idusuario: m.idusuario,
                    codigo: m.idcrm_ass_agenda_evento_usuarioerp,
                    uuid: m.uuid,
                    nome: m.usuario.nome,
                    usuario: m.usuario,
                    executado: m.crmAgendaExecucao != undefined,
                    crmAgendaExecucao: m.crmAgendaExecucao,
                    atrasado:
                        m.crmAgendaExecucao != undefined
                            ? data_hora_fim < new Date(m.crmAgendaExecucao.data_hora_inicio)
                            : data_hora_fim < agora,
                    situacao: m.situacao,
                    iCanChange: iCanChange,
                };
            });
        },
        resetByDataInicio(value) {
            if (value == null) {
                this.repeticaoSelected = this.repeticaoSelect[0];
            }
            this.resetRepeticao(this.repeticaoSelected);
        },
        resetRepeticao(value) {
            if (value.id == 0) {
                this.evento.crmAgenda.repeticao_qtd_ocorrencias = 2;
                this.diasSemanaSelected = [];
                this.datafinal = null;
            } else {
                if (value.id == 2 || value.id == 3 || value.id == 5) {
                    this.diasSemanaSelected = [];
                    let weekDay = this.datainicial.getDay();
                    this.diasSemanaSelected.push(
                        this.diasSemanaSelect.find((f) => f.value == weekDay + 1)
                    );
                } else if (value.id == 4) {
                    this.diasSemanaSelected = [];
                }
                this.changeTerminaPor(this.terminaPorSelected);
            }
        },
        selectDiaDaSemana(dataInicial) {
            if (dataInicial != null) {
                let weekDay = dataInicial.getDay();
                this.diaSemanaSelectedFromDataInicial = this.diasSemanaSelect.find(
                    (f) => f.value == weekDay + 1
                );
                this.checkOccurrenceOfDayInMonth(dataInicial);
            }
        },
        addWeeks(date, weeks) {
            date.setDate(date.getDate() + 7 * weeks);
            return date;
        },
        checkOccurrenceOfDayInMonth(dataInicial) {
            // Quantas vezes no mês já teve esse dia da semana
            let nextWeek = new Date(dataInicial);
            nextWeek.setDate(nextWeek.getDate() + 7);
            this.lastOccurrenceDayOfWeekInMonth = nextWeek.getMonth() != dataInicial.getMonth();

            if (this.repeticaoSelect.find((f) => f.id == 5) != undefined) {
                if (this.repeticaoSelected.id == 5) {
                    this.repeticaoSelected = this.repeticaoSelect[0];
                }
                this.repeticaoSelect.splice(-1);
            }
            if (this.lastOccurrenceDayOfWeekInMonth) {
                this.repeticaoSelect.push({ label: 'mensal', id: 5 });
            }

            let firstDay = new Date(dataInicial.getFullYear(), dataInicial.getMonth(), 1);

            let difference_In_Time = dataInicial.getTime() - firstDay.getTime();
            // To calculate the no. of days between two dates
            let difference_In_Days = difference_In_Time / (1000 * 3600 * 24);
            let difference_In_Weeks = difference_In_Days / 7;

            this.occurrenceOfDayInMonth = Math.trunc(difference_In_Weeks) + 1;
        },
        changeTerminaPor(terminaPor) {
            if (terminaPor.id == 0) {
                this.evento.crmAgenda.repeticao_qtd_ocorrencias = 2;
                if (this.datafinal == null) {
                    this.datafinal = this.addWeeks(new Date(this.datainicial), 5);
                }
            } else {
                this.datafinal = null;
            }
        },
        save() {
            this.isLoading = true;

            if (
                !this.validation.validate(this.$root, this.evento, this.$refs, {
                    tipoAgendaSelected: this.tipoAgendaSelected,
                    colaboradorSelected: this.colaboradorSelected,
                    repeticaoSelected: this.repeticaoSelected,
                    terminaPorSelected: this.terminaPorSelected,
                    diasSemanaSelected: this.diasSemanaSelected,
                    horaInicio: this.horaInicio,
                    horaFim: this.horaFim,
                    datainicial: this.datainicial,
                    datafinal: this.datafinal,
                })
            ) {
                this.isLoading = false;
                return;
            }

            if (this.isUpdate) {
                this.formataParaAlterar();
            } else {
                this.formataParaSalvar();
            }
        },
        formataParaSalvar() {
            this.evento.crmAgenda.idtipoagendaatividade = this.tipoAgendaSelected.id;

            this.evento.crmAssAgendaEventoUsuarioList = [];
            this.colaboradorSelected.forEach((colaborador) => {
                this.evento.crmAssAgendaEventoUsuarioList.push({
                    idusuario: colaborador.idusuario,
                });
            });

            if (this.clienteSelected != null) {
                this.evento.crmAgenda.idcliente = this.clienteSelected.id;
                if (this.propriedadeSelected != null) {
                    this.evento.crmAgenda.uuidpropriedade = this.propriedadeSelected.uuid;
                } else {
                    this.evento.crmAgenda.uuidpropriedade = null;
                }
            } else {
                this.evento.crmAgenda.idcliente = null;
                this.evento.crmAgenda.uuidpropriedade = null;
            }

            this.evento.crmAgenda.repeticao_data_inicio = this.$moment(this.datainicial).format(
                'YYYY-MM-DD'
            );
            this.evento.data_hora_inicio = this.evento.crmAgenda.repeticao_data_inicio + ' ';

            if (this.terminaPorSelected.id == 1) {
                this.datafinal = null;
                this.evento.crmAgenda.repeticao_data_fim = null;
            }
            if (this.datafinal != null) {
                this.evento.crmAgenda.repeticao_data_fim = this.$moment(this.datafinal).format(
                    'YYYY-MM-DD'
                );
                this.evento.data_hora_fim = this.evento.crmAgenda.repeticao_data_fim + ' ';
            } else {
                this.evento.data_hora_fim = this.evento.crmAgenda.repeticao_data_inicio + ' ';
            }

            this.evento.data_hora_inicio +=
                this.horaInicio.HH != '' && this.horaInicio.mm != ''
                    ? this.horaInicio.HH + ':' + this.horaInicio.mm + ':00'
                    : null;

            this.evento.data_hora_inicio = this.$moment(this.evento.data_hora_inicio);

            this.evento.data_hora_fim +=
                this.horaFim.HH != '' && this.horaFim.mm != ''
                    ? this.horaFim.HH + ':' + this.horaFim.mm + ':00'
                    : null;

            this.evento.data_hora_fim = this.$moment(this.evento.data_hora_fim);

            this.evento.crmAgenda.repeticao_tipo = this.repeticaoSelected.id;

            if (this.diasSemanaSelected != null) {
                this.evento.crmAgenda.repeticao_dias = this.diasSemanaSelected
                    .map((e) => e.value)
                    .join(',');
            } else {
                this.evento.crmAgenda.repeticao_dias = null;
            }

            if (this.notificacao.pupup) {
                this.evento.notificacao = 2;
            } else if (this.notificacao.topo) {
                this.evento.notificacao = 1;
            } else {
                this.evento.notificacao = 0;
            }

            this.evento.crmAgenda.diaSemanaSelectedFromDataInicial = this.diaSemanaSelectedFromDataInicial.value;

            this.evento.crmAgenda.lastOccurrenceDayOfWeekInMonth = this.lastOccurrenceDayOfWeekInMonth;

            this.evento.crmAgenda.idusuario_insercao = this.$store.state.user.usuario.id;

            this.mandaSalvar();
        },
        formataParaAlterar() {
            this.mandaSalvar();
        },
        mandaSalvar() {
            let agendaTemp = { ...this.evento };
            agendaTemp = this.mapTosave(
                agendaTemp,
                'datahorainc',
                'data_hora_inicio',
                'data_hora_fim',
                'uuid',
                'uuidcrm_agenda',
                'idcrm_agenda_eventoerp'
            );
            agendaTemp.crmAgenda = this.mapTosave(
                agendaTemp.crmAgenda,
                'datahorainc',
                'repeticao_data_inicio',
                'uuid',
                'idcrm_agendaerp'
            );

            this.isSaving = true;
            this.service
                .save(agendaTemp)
                .then((value) => {
                    if (value.message == null) {
                        let msg = this.$t(
                                this.evento.uuid != null
                                    ? 'msg-edit-sucesso-n'
                                    : 'msg-save-sucesso-n', 
                                { n: this.$t('agenda') }
                            );
                        this.$root.showMessage('success', msg, true, false);
                        if (this.isUpdate) {
                            this.$emit('updated', true);
                        } else {
                            this.$emit('saved', true);
                        }
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    }
                })
                .catch((e) => {
                    if (e.body && !this.isNull(e.body.message) && this.$te(e.body.message)) {
                        this.$root.showMessage('alert', this.$t(e.body.message), true, false);
                    } else {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                    }
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                });
        },
        ordenaDias(dias) {
            dias.sort((a, b) => (a.value > b.value ? 1 : -1));
        },
        getLabelRepeticao(option) {
            if (option == null) return;
            let label = this.$t(option.label);
            let diaSemana =
                this.diaSemanaSelectedFromDataInicial != null
                    ? this.$t(this.diaSemanaSelectedFromDataInicial.label)
                    : '';
            if (option.id == 2) {
                label += ': Todo(a) ' + diaSemana;
            } else if (option.id == 3) {
                label += ': ' + this.occurrenceOfDayInMonth + 'º ' + diaSemana;
            } else if (option.id == 4) {
                label += ': Todo dia ' + this.datainicial.getDate();
            } else if (option.id == 5) {
                label += ': Todo(a) último(a) ' + diaSemana;
            }
            return label;
        },
        changeCheckTopo() {
            this.notificacao.topo = !this.notificacao.topo;
            if (!this.notificacao.topo) this.notificacao.pupup = false;
        },
        changeCheckPupUp() {
            this.notificacao.pupup = !this.notificacao.pupup;
            if (this.notificacao.pupup) this.notificacao.topo = true;
        },
        addHours(date, hours) {
            date.setHours(date.getHours() + hours);
            return date;
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
        padding-left: 0;
    }
    .sovis-container-user {
        cursor: pointer;
        padding: 2px 10px;
        border: solid 1px $primary-color;
        background-color: #f0f0f0;
        border-radius: 6px;
        display: flex;
        .qtd-users {
            font-weight: bolder;
            font-size: 18px;
            margin: 0 10px;
            &.is-success {
                color: $green-alert;
            }
            &.is-danger {
                color: $orange;
            }
        }
    }
}
</style>
